// extracted by mini-css-extract-plugin
export var accordionBorder = "block-module--accordion-border--1f997";
export var accordionIcon = "block-module--accordion-icon--d44a6";
export var accordionText = "block-module--accordion-text--85bc3";
export var blueDeep = "block-module--blue-deep--614b4";
export var borderedIcon = "block-module--bordered-icon--449ed";
export var card = "block-module--card--e93f9";
export var cardImg = "block-module--card-img--9c106";
export var colourCards = "block-module--colour-cards--49a36";
export var comparisonBg = "block-module--comparison-bg--80156";
export var comparisonBgItem = "block-module--comparison-bg-item--214ad";
export var comparisonMobile = "block-module--comparison-mobile--4777a";
export var comparisonOptions = "block-module--comparison-options--1f53f";
export var downloadContainer = "block-module--download-container--61557";
export var featureCard = "block-module--feature-card--0a623";
export var featureCardImg = "block-module--feature-card-img--03f68";
export var featureCards = "block-module--feature-cards--2d6af";
export var featureCarousel = "block-module--feature-carousel--d3d2d";
export var featureCarouselCard = "block-module--feature-carousel-card--a7b97";
export var featureCarouselComingSoon = "block-module--feature-carousel-coming-soon--28c83";
export var featureCarouselImg = "block-module--feature-carousel-img--67d58";
export var featureCarouselPaging = "block-module--feature-carousel-paging--e14ea";
export var leftImg = "block-module--left-img--87855";
export var logoDecalTop = "block-module--logo-decal-top--89251";
export var quote = "block-module--quote--a5c02";
export var quoteContainer = "block-module--quote-container--3ac72";
export var quoteContainerCopy = "block-module--quote-container-copy--9ad1d";
export var quoteContainerQuotes = "block-module--quote-container-quotes--e4326";
export var quoteImage = "block-module--quote-image--21551";
export var quoteImageCenter = "block-module--quote-image-center--2be1a";
export var quoteImageRight = "block-module--quote-image-right--25583";
export var ratingIcon = "block-module--rating-icon--6dcce";
export var ratingTitle = "block-module--rating-title--af596";
export var reviewsCard = "block-module--reviews-card--99f4b";
export var reviewsCardAltImage = "block-module--reviews-card-alt-image--e27c3";
export var rightImg = "block-module--right-img--fc6a5";
export var sectionHeadingDecal = "block-module--section-heading-decal--ca82a";
export var sectionHeadingDecalBottomLeft = "block-module--section-heading-decal-bottom-left--58c99";
export var sectionHeadingDecalBottomRight = "block-module--section-heading-decal-bottom-right--02041";
export var sectionHeadingDecalTopLeft = "block-module--section-heading-decal-top-left--75434";
export var sectionHeadingDecalTopRight = "block-module--section-heading-decal-top-right--feaaa";
export var statsButtons = "block-module--stats-buttons--ca1d4";
export var statsCircle = "block-module--stats-circle--1c9f6";
export var statsHighlight = "block-module--stats-highlight--f5299";
export var statsImg = "block-module--stats-img--cc187";
export var statsTextBlocks = "block-module--stats-text-blocks--ad7ed";
export var statsTitle = "block-module--stats-title--40987";
export var tabbedMenu = "block-module--tabbed-menu--4d4a8";
export var tabbedMenuNavContainer = "block-module--tabbed-menu-nav-container--e048b";
export var tabbedMenuNavItem = "block-module--tabbed-menu-nav-item--195de";
export var tableList = "block-module--table-list--db380";
export var tableListHeading = "block-module--table-list-heading--54d2d";
export var tableListItem = "block-module--table-list-item--2d3a4";